import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import Sidebar from "../components/dashboard/Sidebar"
import CRODashboard from "../components/dashboard/CRODashboard"
import InvestigatorDashboard from "../components/dashboard/InvestigatorDashboard"
import { useSession } from "@hooks/useSession";
import NavigationService from "@services/navigation.service.js"
import State,{STATE, AppContextState } from "@state"


export default function Dashboard() {
  const navigate = useNavigate()
  const { user, session, clearSession } = useSession()
  const [forceUpdate, setForceUpdate] = useState(0)

  const roleContext = AppContextState.ROLE_CONTEXT;
  const roleContextCRO = AppContextState.ROLE_CONTEXT_CRO;
  const roleContextInvestigator = AppContextState.ROLE_CONTEXT_INVESTIGATOR;

  const [currentRoleContext, setCurrentRoleContext] = useState(STATE[roleContext])

  useEffect(() => {
    if (user && user.role === "participant") {
      console.log("User is a participant, redirecting to /patient-consent-signature")
      navigate("/patient-dashboard")
    }
  }, [user, navigate])

  const [refresh, setRefresh] = useState(0)


  useEffect(() => {
    const handleRoleContextChange = (newValue) => {
      console.log("Listener triggered: ROLE_CONTEXT changed to", newValue)
      setCurrentRoleContext(newValue)
    }
    State.registerListener(AppContextState.ROLE_CONTEXT, handleRoleContextChange);
    return () => {
      State.unregisterListener(AppContextState.ROLE_CONTEXT, handleRoleContextChange);
    };
  }, []);

  useEffect(() => {
    console.log("--- useEffect for role initialization triggered ---")
    console.log("Current user from session:", user)
    console.log("Current STATE[roleContext] before update:", STATE[roleContext])


    if (user && user.role) {
      let initialRoleContext = AppContextState.ROLE_CONTEXT_CRO 
      if (user.role === "investigator") {
        initialRoleContext = AppContextState.ROLE_CONTEXT_INVESTIGATOR
      } else if (user.role === "cro") {
        initialRoleContext = AppContextState.ROLE_CONTEXT_CRO
      }
      console.log("Determined initialRoleContext based on user.role:", initialRoleContext)

      if (STATE[roleContext] !== initialRoleContext) {
        console.log(`Setting STATE[${roleContext}] from "${STATE[roleContext]}" to "${initialRoleContext}"`)
        State.setValue(roleContext, initialRoleContext)
      } else {
        console.log(`STATE[${roleContext}] is already "${initialRoleContext}", no update needed.`)
      }
    } else {
      console.log("User or user.role is not available yet.")
    }
    console.log("--- End useEffect for role initialization ---")

    
  }, [user, roleContext]) 


  const isInvestigator = STATE[roleContext] === roleContextInvestigator
  const isCRO = STATE[roleContext] === roleContextCRO

  console.log("--- Dashboard Render Cycle Logs ---")
  console.log("STATE[roleContext] at render (global):", STATE[roleContext]) 
  console.log("currentRoleContext (local state):", currentRoleContext) 
  console.log("isInvestigator (calculated):", isInvestigator)
  console.log("isCRO (calculated):", isCRO)
  console.log("--- End Dashboard Render Cycle Logs ---")
   
  useEffect(() => {
    if(!session){
      NavigationService.navigateTo("/")
    }
  }, [user, session]) 

   useEffect(() => {
    //if needed
  }, [STATE[AppContextState.ROLE_CONTEXT]])
  

  

  

  const handleRoleSwitch = () => {
    // TODO: implement role switch
   /* State.setValue(roleContext,isCRO ? roleContextInvestigator : roleContextCRO)
    setForceUpdate(forceUpdate + 1) */
  }
    

 


  const getSwitchButtonText = () => {
    if (isCRO) {
      return "Switch to Investigator"
    } else {
      return "Switch to CRO"
    }
  }

  console.log("Dashboard rendering with role:", STATE[roleContext])
  console.log("isInvestigator:", isInvestigator)
  console.log("isCRO:", isCRO)
  console.log("forceUpdate:", forceUpdate)
  console.log('=== AppContextState === Dashboard.jsx === key: 485347 ===');
  console.dir(AppContextState, { depth: null, colors: true })
  console.log('=================================');

  return (
    <div className="flex h-screen bg-dashboard-bg">
      {/* Sidebar  */}
      <Sidebar
        activeLink="Dashboard"
      />
      {isInvestigator ? <InvestigatorDashboard /> : <CRODashboard />}
      
    </div>
  )
}